import React, { Fragment, useEffect, useState } from 'react';
import { url } from '../constant.tsx';
import { ReactFormGenerator } from 'react-form-builder2';
import { showError, showSuccess, showWarning } from '@bepro-travel/fe.utils';
import { Button, FormGroup } from '@bepro-travel/fe.ui';
import Skeleton from 'react-loading-skeleton';
import { useSearchParams } from 'react-router-dom';

const Answers = () => {
  const [formData, setFormData] = useState([]);
  const [answers, setAnswers] = useState<any[]>([]);
  const [hasErrors, setHasErrors] = useState(false);
  const [order, setOrder] = useState<any>();
  const [activePaxIndex, setActivePaxIndex] = useState(-1);
  const [urlParams] = useSearchParams();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [loadingPax, setLoadingPax] = useState(false);

  useEffect(() => {
    const dataId = urlParams.get('data');

    (async () => {
      const response = await fetch(`${url}/Visa/GetData`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: dataId }),
      }).then((res) => res.json());

      setHasErrors(response?.hasErrors);
      if (!response?.hasErrors) {
        setFormData(JSON.parse(response.jsonStructure));
        setOrder(response.order);

        let newAnswers: any = [];
        for (let key in response.jsonData) {
          if (response.jsonData[key]) {
            newAnswers.push(JSON.parse(response.jsonData[key]));
          } else {
            newAnswers.push(undefined);
          }
        }
        setAnswers(newAnswers);

        newAnswers.forEach((answer, answerIndex) => {
          answer
            ?.filter((item) => item.isFile)
            .forEach(async (item) => {
              try {
                const res = await fetch(`${url}/Visa/DownloadFile`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    data: dataId,
                    fileKey: item.fileKey,
                    fileName: '1',
                  }),
                });

                const resData = await res.json();

                if (resData.base64File) {
                  setAnswers((prevAnswers) => {
                    const newAnswers = [...prevAnswers];
                    const fileIndex = newAnswers[answerIndex].findIndex(
                      (a) => a.name === item.name
                    );

                    const labelBody = JSON.parse(response.jsonStructure).find(
                      (i: any) => {
                        return (
                          i.field_name ===
                          newAnswers[answerIndex][fileIndex].name
                        );
                      }
                    );

                    newAnswers[answerIndex][fileIndex] = {
                      ...item,
                      value: `data:${resData.mimeType};base64,${resData.base64File}`,
                      label: labelBody.label,
                    };

                    console.log(newAnswers);
                    return newAnswers;
                  });
                }
              } catch (err) {}
            });
        });
      }
    })();
  }, []); // eslint-disable-line

  const uploadFiles = async (files, answerIndex) => {
    const acceptedTypes = [
      'image/jpeg',
      'image/png',
      'image/gif',
      'application/pdf',
    ];

    const validFiles = files.filter(
      (file) =>
        acceptedTypes.includes(file.value.type) &&
        file.value.size < 10 * 1024 * 1024
    );

    if (files.length !== validFiles.length) {
      showWarning('לא כל הקבצים הועלו. פורמט קובץ שגוי.');
    }

    validFiles.forEach(async (file) => {
      try {
        function fileToBase64(file: File): Promise<string> {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () => {
              const result = reader.result as string; // Ensure the result is a string
              resolve(result.split('base64,')[1]); // Extract Base64 part
            };

            reader.onerror = (error) => reject(error);

            reader.readAsDataURL(file);
          });
        }

        const params = {
          fileName: file.value.name,
          fileKey: file.fileKey,
          data: urlParams.get('data'),
          base64File: await fileToBase64(file.value),
          mimeType: file.value.type,
        };

        const imgRes = await fetch(`${url}/Visa/UploadFile`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(params),
        }).then((t) => t.json());

        if (imgRes?.success) {
          setAnswers((prev) => {
            const newAnswers = [...prev];
            const fileIndex = newAnswers[answerIndex].findIndex(
              (a) => a.name === file.name
            );

            const labelBody: any = formData.find((i: any) => {
              return i.field_name === newAnswers[answerIndex][fileIndex].name;
            });

            newAnswers[answerIndex][fileIndex] = {
              ...file,
              value: `data:${file.value.type};base64,${params.base64File}`,
              label: labelBody.label,
            };
            return newAnswers;
          });
        }
      } catch (err) {}
    });
  };

  const saveForm = async (data) => {
    const dataId = urlParams.get('data');
    const { paxCode } = order.paxes[activePaxIndex];

    const formattedData = data.map((item, index) => {
      if (
        item.name.includes('file_upload') &&
        item.value &&
        typeof item.value === 'object'
      ) {
        return {
          ...item,
          isFile: true,
          fileKey: item.name + Date.now(),
        };
      } else if (item.name.includes('file_upload')) {
        return answers[activePaxIndex][index];
      }

      return item;
    });

    console.log(answers[activePaxIndex]);
    console.log(formattedData);

    uploadFiles(
      formattedData.filter(
        (item) => item.isFile && item.value && typeof item.value === 'object'
      ),
      activePaxIndex
    );

    await fetch(`${url}/Visa/SaveData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        data: dataId,
        jsonData: JSON.stringify(formattedData),
        paxCode,
      }),
    })
      .then(() => {
        showSuccess('המידע נשמר בהצלחה');
        setAnswers((prev) => {
          const newAnswers = [...prev];

          newAnswers[activePaxIndex] = [
            ...formattedData.map((item, index) => {
              if (item.isFile) {
                return newAnswers[activePaxIndex][index];
              } else {
                return item;
              }
            }),
          ];

          return newAnswers;
        });
      })
      .catch(() => {
        showError('שגיאה בשמירת המידע');
      });
  };

  const savePax = async () => {
    const dataId = urlParams.get('data');
    const prevActivePaxIndex = activePaxIndex;
    const pax = order.paxes[prevActivePaxIndex];
    setLoadingPax(true);

    try {
      const res: any = await fetch(`${url}/Visa/ChangePax`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: dataId,
          pax: {
            firstName: firstName,
            lastName: lastName,
            email: '',
            phone: '',
            paxCode: pax.paxCode,
          },
        }),
      });

      const resData = await res.json();
      if (resData.success) {
        showSuccess('נתוני נוסע נשמרו בהצלחה');
        const newPaxes = [...order.paxes];
        newPaxes[prevActivePaxIndex] = { ...pax, firstName, lastName };
        setOrder({ ...order, paxes: newPaxes });
      }
    } catch (error) {
      showError('שגיאה בשמירת המידע');
    } finally {
      setLoadingPax(false);
    }
  };

  const onClickPax = (index) => {
    setActivePaxIndex(index);

    setFirstName(order.paxes[index].firstName);
    setLastName(order.paxes[index].lastName);
  };

  const onClickFile = (file) => {
    const newWindow = window.open();
    if (newWindow) {
      if (file.value.includes('application/pdf')) {
        newWindow.document.write(
          `<embed src="${file.value}" width="100%" height="100%">`
        );
        newWindow.document.title = file.label;
      } else {
        newWindow.document.write(
          `<img src="${file.value}" alt="Base64 Image" style="max-width: 100vw;"> `
        );
        newWindow.document.title = file.label;
      }
    }
  };

  return (
    <div className="f-wrapper">
      {hasErrors && (
        <div style={{ marginTop: 20, fontSize: 20, textAlign: 'center' }}>
          המידע לא נמצא
        </div>
      )}

      {!!order && (
        <div className="generator text-lh rtl answers">
          <div className="title text-center">
            הזמנה #{order.segments?.[0]?.orderId}
          </div>
          <div className="title text-center">
            {order.segments?.[0]?.itemDesc}
          </div>
          <div className="display-flex">
            <div className="text-bold" style={{ width: 60 }}>
              שם:{' '}
            </div>
            {order.owner.firstName + ' ' + order.owner.lastName}
          </div>
          <div className="display-flex">
            <div className="text-bold" style={{ width: 60 }}>
              אימייל:{' '}
            </div>
            <div>{order.owner.email}</div>
          </div>

          <div className="display-flex">
            <div className="text-bold" style={{ width: 60 }}>
              טלפון:{' '}
            </div>
            <div>{order.owner.phone}</div>
          </div>
          <div className="display-flex">
            <div className="text-bold" style={{ width: 60 }}>
              מחיר:
            </div>
            <div>{order.param_5}</div>
          </div>
        </div>
      )}

      {!order && (
        <Fragment>
          <div className="generator text-lh rtl answers">
            <div className="title text-center">
              <Skeleton width={300} />
            </div>
            <div className="title text-center">
              <Skeleton width={220} />
            </div>
            <div className="display-flex">
              <div className="text-bold" style={{ width: 60 }}>
                <Skeleton width={50} />
              </div>
              <Skeleton width={200} />
            </div>
            <div className="display-flex">
              <div className="text-bold" style={{ width: 60 }}>
                <Skeleton width={40} />
              </div>
              <Skeleton width={210} />
            </div>

            <div className="display-flex">
              <div className="text-bold" style={{ width: 60 }}>
                <Skeleton width={45} />
              </div>
              <Skeleton width={100} />
            </div>
            <div className="display-flex">
              <div className="text-bold" style={{ width: 60 }}>
                <Skeleton width={50} />
              </div>
              <Skeleton width={100} />
            </div>
          </div>
          <div className="generator rtl  answers-pax">
            {[...Array(2)].map((_, index) => (
              <div
                key={index}
                style={{
                  lineHeight: 2,
                }}
              >
                <div>
                  <Skeleton width={300} />
                </div>
              </div>
            ))}
          </div>
        </Fragment>
      )}

      {!!order?.paxes.length && (
        <div className="generator rtl answers-pax">
          {order.paxes.map((pax, index) => (
            <div
              key={index}
              style={{
                cursor: 'pointer',
                fontWeight: activePaxIndex === index ? 600 : 400,
                lineHeight: 2,
              }}
            >
              <div onClick={() => onClickPax(index)} className="display-flex">
                {index + 1}. {pax.firstName} {pax.lastName} - מילוי טופס
              </div>
            </div>
          ))}
        </div>
      )}

      {!!formData.length &&
        answers.map((answer, index) => (
          <Fragment key={index}>
            {activePaxIndex === index && (
              <div className="rtl generator answers">
                <div className="color-danger mb-10">
                  {'נא למלא שם פרטי ושם משפחה באנגלית כפי שמופיע בדרכון'}
                </div>
                <div className="row">
                  <FormGroup
                    label="שם פרטי"
                    className="col-md-6 col-12"
                    value={firstName}
                    onChange={setFirstName}
                  />
                  <FormGroup
                    label="שם משפחה"
                    className="col-md-6 col-12"
                    value={lastName}
                    onChange={setLastName}
                  />
                </div>

                <Button
                  title="עדכן שם"
                  onClick={savePax}
                  disabled={loadingPax}
                />

                <div className="divider mt-30 mb-10"></div>

                <div className="gallery">
                  {answer
                    ?.filter?.(
                      (item) =>
                        typeof item.value === 'string' &&
                        item.value.includes('base64')
                    )
                    .map((file, index) => (
                      <div key={index} className="gallery-img">
                        <div
                          className="gallery-title cur-poi"
                          onClick={() => onClickFile(file)}
                        >
                          {file.label}
                        </div>
                        <div
                          className="gallery-img-wr"
                          onClick={() => onClickFile(file)}
                        >
                          {file.value.includes('image/') && (
                            <img src={file.value} alt="f"></img>
                          )}
                          {file.value.includes('application/pdf') && (
                            <iframe src={file.value} title={file.label} />
                          )}
                        </div>
                      </div>
                    ))}
                </div>

                <ReactFormGenerator
                  data={formData}
                  onSubmit={saveForm}
                  answer_data={answer}
                  action_name="לשמור"
                  form_action=""
                  form_method=""
                />
              </div>
            )}
          </Fragment>
        ))}
    </div>
  );
};

export default Answers;
